<div class="stacksBlockContainer" *ngIf="!mobile && !this.builderService.isFromGenie()">
  <p>{{ daysRemaining }} {{ 'Days Remaining in your trial' | translate }}</p>
</div>

<div class="stacksBlockContainer" *ngIf="mobile && !this.builderService.isFromGenie()">
  <p *ngIf="builderService.projectStartDate">{{ daysRemaining }} Days Remaining in your trial</p>
  <a [routerLink]="['/billing']" (click)="logAction()" class="stacksBtn red lightBtn">{{ 'Upgrade Plan' | translate }}</a>
</div>
